import c from 'classnames';

import { useCurrency } from '@contexts/CurrencyContext';
import { useRouter } from '@contexts/Router/RouterContext';
import { AnimationStates } from 'ui-components';
import { LOCALE_TO_DISPLAY_NAME } from 'utils';
import { HeaderMenuListItem } from '../common/HeaderMenuListItem';
import {
  SALE_NAV_RED_CLASSES,
  isSaleLink,
  useSaleNavRedTreatment,
} from '../common/saleNav';
import { NavigationItem } from '../types';

type MobileMainNavigationProps = {
  items: NavigationItem[];
  languages: NavigationItem;
  currencies: NavigationItem;
  animationStates: AnimationStates;
  handleItemSelect: (item: NavigationItem) => void;
};

export const MobileMainNavigation = ({
  items,
  languages,
  currencies,
  handleItemSelect,
  animationStates,
}: MobileMainNavigationProps) => {
  const router = useRouter();
  const { locale } = router;
  const selectedLanguage = LOCALE_TO_DISPLAY_NAME[locale];
  const { currency } = useCurrency();
  const isSaleRedTreatment = useSaleNavRedTreatment();

  return (
    <div
      className={c('mb-10 w-full transition duration-300', {
        'opacity-1': animationStates.isAnimatedIn,
        'opacity-0': animationStates.isAnimating,
      })}
    >
      {/* Main Menu */}
      <ul>
        {items.map((item) => {
          const hasColumns = Boolean(item.columns && item.columns.length > 0);
          return (
            <li key={item.mainLink.value}>
              <HeaderMenuListItem
                hasChildren={hasColumns}
                value={item.mainLink.value}
                href={item.mainLink.href}
                // Leaf items (e.g. a Sale link with no sub-nav) render as a
                // link and navigate; only items with columns open a submenu.
                handleSelect={
                  hasColumns ? () => handleItemSelect(item) : undefined
                }
                classNames="py-4"
                colorClassNames={
                  isSaleRedTreatment && isSaleLink(item.mainLink.href)
                    ? SALE_NAV_RED_CLASSES
                    : undefined
                }
              />
            </li>
          );
        })}
      </ul>
      {/* Languages */}
      <div className="mt-10">
        <div className="caption text-grey-500">{languages.mainLink.value}</div>
        <ul>
          <HeaderMenuListItem
            hasChildren={true}
            value={selectedLanguage}
            handleSelect={() => handleItemSelect(languages)}
            classNames="py-4"
          />
        </ul>
      </div>
      {/* Currencies */}
      <div className="mt-10">
        <div className="caption text-grey-500">{currencies.mainLink.value}</div>
        <ul>
          <HeaderMenuListItem
            hasChildren={true}
            value={currency}
            handleSelect={() => handleItemSelect(currencies)}
            classNames="py-4"
          />
        </ul>
      </div>
    </div>
  );
};
